import CurrencyFormat from 'react-currency-format';
import * as Config from '../../config/config';

function CustomCurrencyFormat(props) {
    let amount = (props?.amount && typeof props.amount == 'object')?props.amount['$numberDecimal']:props.amount;
    if(props.round || props.round == undefined) {
        amount = Number(amount).toFixed(2);        
    }
    
    return (
        <CurrencyFormat value={amount} 
                        displayType={'text'} 
                        decimalScale={2}
                        thousandSeparator={true} prefix={Config.CURRENCY_SYMBOL} 
                        renderText={value => <span>{value}</span>} />  
    )
}

export default CustomCurrencyFormat;